import React, { useEffect, useState } from 'react';
import FeedbackForm from 'Feedback/FeedbackForm';
import { Button, Modal } from '@equinor/opt-ui-core';
import { Close, CommentAdd } from '@equinor/opt-ui-icons';
import { useCreateFeedbackMutation } from 'Utils/routes/hooks/useCreateFeedbackMutation';
const FeedbackPanel = () => {
    const { mutate, isPending, isSuccess } = useCreateFeedbackMutation();
    const [isOpen, setIsOpen] = useState(false);
    const openDialog = () => setIsOpen(true);
    const closeDialog = () => setIsOpen(false);
    useEffect(() => {
        if (isSuccess) {
            closeDialog();
        }
    }, [isSuccess]);
    const handleSubmit = (summary, description) => mutate({ summary, description });
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { onClick: openDialog, variant: "ghost", color: "secondary", startIcon: React.createElement(CommentAdd, null) }, "Feedback"),
        React.createElement(Modal, { open: isOpen, closeIcon: React.createElement(Close, null), title: "Submit OMNIA.Prevent feedback", onClose: closeDialog, backdropProps: { closable: true } },
            React.createElement(FeedbackForm, { onSubmit: handleSubmit, isSubmitting: isPending }))));
};
export default FeedbackPanel;
